<template>
  <b-modal
    :id="modalId"
    title="Verification History"
    no-close-on-backdrop
    hide-footer
    static
    lazy
  >
    <template #modal-header-close>
      <i class="fa fa-close" />
    </template>
    <b-row>
      <b-col>
        <verifications-table
          :compliance-document-coverage-id="value.id"
          :filters="{ paginate: false }"
          :per-page="1"
          :show-per-page="false"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="3"
        offset="9"
      >
        <b-button
          variant="primary"
          block
          id="version-changes-close-button"
          @click="closeModal"
        >
          Close
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import VerificationsTable from '@/components/admin/complianceDocumentVerifications/Table.vue';

export default {
  name: 'ComplianceDocumentVerificationsTableModal',
  components: {
    VerificationsTable,
  },
  props: {
    value: Object,
  },
  methods: {
    closeModal() {
      this.$bvModal.hide(this.modalId);
    },
  },
  computed: {
    modalId() {
      return `compliance-document-verification-table-${this.value.id}-modal`;
    },
  },
};
</script>
